import httpClient from "../httpClient";
import { API_PROCEDURE_DELETE } from "../config";

const deleteProcedure = {
    delete: (id) => httpClient.delete(API_PROCEDURE_DELETE + '/' + id),
};

export default deleteProcedure;